import httpClient from "./httpClient";

const base = "/certifications";

export function generateCertification(identificationId) {
  return httpClient.post(`${base}/generate`, null, { params: { identificationId } }).then((res) => res.data.data);
}

export function listCertifications() {
  return httpClient.get(base).then((res) => res.data.data);
}
